export default "__VITE_ASSET__TJdxPa0N__"